export default __webpack_public_path__ + "static/media/atlascom.d2e01e87.png";